import React, { useState, Fragment, useEffect, useCallback } from 'react';
import { getInboxService, starConversationService } from '../../services/inboxService';
import { getDirectorsByCampCodeService, getDirectorInboxService } from '../../services/superDirectorService';
import { Empty, notification } from 'antd';
import { connect } from 'react-redux';
import { activeUserChatWindowAction, getChatUserListCalbackAction } from '../../store/inbox';
import { getHtml, removeHtmlTags, debounce, SEARCH_DEBOUNCE_DELAY } from '../../helper';
import { AiFillStar, } from 'react-icons/ai';
import { MdMarkUnreadChatAlt, MdOutlineChat, MdSupervisorAccount } from "react-icons/md";
import { IoChevronBackOutline } from 'react-icons/io5';
import { ProgramLoader } from '../reuse/SVG';
import { unreadCountAction } from '../../store/chat';
import PaginatedComponent from '../common/Pagination/PaginationComponent';
import UserCard from './UserCard';

const limit = 10
const DIRECTORS_TAB = 4
const findIsStarred = (item, userId) => {
    if (item.hasOwnProperty('starredMsg')) {
        if (item?.starredMsg?.length) return item.starredMsg.find(i => i.userId !== userId).isStarred;
        return false;
    }
    return false;
};
const ChatUserList = props => {
    const [list, setList] = useState([]);
    const [search, setSearch] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [chatTab, setChatTab] = useState(1);
    const [loader, setLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [totalUser, setTotalUser] = useState(0);
    const userId = props.userProfile?._id
    const isSuperDirector = !!props.userProfile?.isSuperDirector

    const [directors, setDirectors] = useState([]);
    const [directorLoader, setDirectorLoader] = useState(false);
    const [selectedDirector, setSelectedDirector] = useState(null);

    const getList = (pageNo=1) => {
        setLoader(true)
        let query = `?pageNo=${pageNo}&limit=${limit}&chatType=${chatTab}&search=${search}`
        getInboxService(query).then(res => {
            props.getChatUserListCalbackAction(0);

            if (res?.data?.statusCode) {
                setList(res.data.responseData.result)
                setTotalUser(res.data.responseData?.count || 0);
                props.unreadCountAction();
                setLoader(false);
            }
        }).catch(error => {
            setLoader(false)
            console.log(error)
        }).finally(() => {
            setLoader(false)
        })
    }

    const getDirectors = () => {
        if (!props.userProfile?.campCode) return;
        setDirectorLoader(true);
        getDirectorsByCampCodeService(props.userProfile.campCode).then(res => {
            if (res?.data?.statusCode) {
                setDirectors(res.data.responseData.result || res.data.responseData || []);
            }
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setDirectorLoader(false);
        })
    }

    const getDirectorInboxList = (pageNo = 1) => {
        if (!selectedDirector?._id) return;
        setLoader(true);
        let query = `?pageNo=${pageNo}&limit=${limit}&chatType=1&search=${search}&directorUserId=${selectedDirector._id}`
        getDirectorInboxService(query).then(res => {
            props.getChatUserListCalbackAction(0);

            if (res?.data?.statusCode) {
                setList(res.data.responseData.result)
                setTotalUser(res.data.responseData?.count || 0);
            }
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setLoader(false)
        })
    }

    useEffect(() => {
        if (chatTab === DIRECTORS_TAB) return;
        setPage(1)
        getList(1)
    }, [search, chatTab, props.getChatUserListCalback]);

    useEffect(() => {
        if (chatTab !== DIRECTORS_TAB) return;
        if (!selectedDirector) {
            getDirectors();
        } else {
            setPage(1);
            getDirectorInboxList(1);
        }
    }, [chatTab, selectedDirector, search, props.getChatUserListCalback]);

    const debouncedSearch = useCallback(debounce(value => setSearch(value), SEARCH_DEBOUNCE_DELAY), []);

    const handlePageNoChange = (page) => {
        if (chatTab === DIRECTORS_TAB && selectedDirector) {
            getDirectorInboxList(page)
        } else {
            getList(page)
        }
        setPage(page)
    }
    const handleClick = (item) => {
        props.activeUserChatWindowAction(item);
         props.toggleSidebar(false);
    }
    const handleDirectorChatClick = (item) => {
        props.activeUserChatWindowAction({ ...item, directorUserId: selectedDirector._id, directorName: selectedDirector.name });
        props.toggleSidebar(false);
    }
    const toggleStar = (e, item) => {
        let isStarred = !findIsStarred(item, userId);
        e.stopPropagation()
        const params = {
            groupId: item.groupId,
            isStarred,
            userId,
        }
        starConversationService(params).then(res => {
            if (res?.data?.statusCode) {
                notification.open({
                    description: `⭐ Successfuly ${isStarred ? "starred" : "un-starred"} conversation for ${item?.userId[0]?.name}.`,
                });
                if (chatTab === DIRECTORS_TAB && selectedDirector) {
                    getDirectorInboxList(page);
                } else {
                    getList();
                }
            } else {
                notification.open({
                    description: `Something went wrong please try again.`,
                });
            }

        })
    };

    const handleChatTab =(tabNo) => {
        setChatTab(tabNo);
        setSelectedDirector(null);
        setSearch('');
        // setPage(1);
    }

    const handleSelectDirector = (director) => {
        setSelectedDirector(director);
    }

    const handleBackToDirectors = () => {
        setSelectedDirector(null);
    }

    // The open chat can be missing from the loaded rows: "Message User" on the booking page opens a
    // user with no conversation yet (no groupId until the first message), or one on a later page.
    // Pin it on top of the unfiltered list so the open chat is always visible and selected.
    const activeChat = props.activeUserChatWindow;
    const activeContactId = activeChat?.type === 1 ? activeChat?.userId?.[0]?._id : undefined;
    const isActiveItem = item => {
        if (activeChat?.groupId) return item.groupId === activeChat.groupId;
        return !!activeContactId && item.type === 1 && !!item.userId?.some(u => String(u?._id ?? u) === String(activeContactId));
    };
    const pinnedChat = chatTab === 1 && !search && !loader && activeContactId && !activeChat.directorUserId && !list.some(isActiveItem)
        ? activeChat
        : null;

    const renderConversationList = (items, onItemClick, isLoading) => {
        if (isLoading) {
            return (
                <div
                    className="program_loader d-flex align-items-center justify-content-center"
                    style={{ height: '100%' }}
                >
                    <div>
                        <ProgramLoader />
                    </div>
                </div>
            );
        }
        return (
            <ul>
                {pinnedChat ? (
                    <li className="d-flex align-items-center active" onClick={() => props.toggleSidebar(false)}>
                        <img className="chat_user_img" src={pinnedChat.userId[0].profileImage ? pinnedChat.userId[0].profileImage : require('../../assets/img/user.png')} alt="" />
                        <div className="chat_user_info">
                            <span>{pinnedChat.userId[0].name}</span>
                            <small>{removeHtmlTags(pinnedChat.lastMessage)}</small>
                        </div>
                    </li>
                ) : null}
                {
                    items.length ? items.map(item => (
                        <li
                            key={item.groupId}
                            className={`d-flex align-items-center
                            ${isActiveItem(item) ? 'active' : ''}`}
                            onClick={item?.scheduleDateTime ? "" :() => onItemClick(item)}
                        >
                            {(item.type === 1) && (item.userId?.length > 0) &&
                                <UserCard
                                    item={item}
                                    findIsStarred={findIsStarred}
                                    toggleStar={toggleStar}
                                    userId= {userId}
                                    timezone={props?.userProfile?.timezone}
                                />
                            }

                            {item.type === 2 ? <Fragment>
                                <img className="chat_user_img" src={item.groupImage ? item.groupImage : require('../../assets/img/user.png')} alt="" />
                                <p>
                                    {item.groupName}
                                    <br />
                                    <small>{removeHtmlTags(item.lastMessage)}</small>
                                </p>

                            </Fragment> : ''}


                        </li>
                    )) : (pinnedChat ? null : <li className="cm_empty"><Empty description="Data Not Found" /></li>)
                }
            </ul>
        );
    }

    return (
        <div style={{maxHeight:'calc(100% - 220px)'}}>
            <div className="chat_user_list_wrapper">

                {!(chatTab === DIRECTORS_TAB && !selectedDirector) &&
                    <div className="contact_search">
                        <i className="icon-search" />
                        <input
                            type="text"
                            value={searchInput}
                            onChange={e => { setSearchInput(e.target.value); debouncedSearch(e.target.value); }}
                            placeholder="Search" />
                    </div>
                }

                {/* <div className='me_pro_user'>
<img src={props?.userProfile?.profileImage || require('../../assets/img/user.png')} />
<p>{props?.userProfile?.name}</p>
</div> */}

                <div className='chat_tabs'>
                    <span className={chatTab === 1 ? 'active' : ''} onClick={() => handleChatTab(1)}>
                        <span className="d-none d-sm-inline">All</span>
                        <span className="d-inline d-sm-none">
                            <MdOutlineChat color="#841f15" size={24}/>
                        </span>
                    </span>
                    <span className={chatTab === 2 ? 'active' : ''} onClick={() => handleChatTab(2)}>
                        <span className="d-none d-sm-inline">Unread</span>
                        <span className="d-inline d-sm-none">
                            <MdMarkUnreadChatAlt color="#841f15" size={24}/>
                        </span>
                    </span>
                    <span className={chatTab === 3 ? 'active' : ''} onClick={() => handleChatTab(3)}>
                        <span className="d-none d-sm-inline">Starred</span>
                        <span className="d-inline d-sm-none">
                            <AiFillStar color="#841f15" size={24} />
                        </span>
                    </span>
                    {isSuperDirector &&
                        <span className={chatTab === DIRECTORS_TAB ? 'active' : ''} onClick={() => handleChatTab(DIRECTORS_TAB)}>
                            <span className="d-none d-sm-inline">Directors</span>
                            <span className="d-inline d-sm-none">
                                <MdSupervisorAccount color="#841f15" size={24}/>
                            </span>
                        </span>
                    }
                </div>

                {
                    chatTab === DIRECTORS_TAB ? (
                        !selectedDirector ? (
                            directorLoader ?
                                <div
                                    className="program_loader d-flex align-items-center justify-content-center"
                                    style={{ height: '100%' }}
                                >
                                    <div>
                                        <ProgramLoader />
                                    </div>
                                </div> :
                                <ul>
                                    {
                                        directors.length ? directors.map(director => (
                                            <li
                                                key={director._id}
                                                className="d-flex align-items-center"
                                                onClick={() => handleSelectDirector(director)}
                                            >
                                                <img className="chat_user_img" src={director.profileImage ? director.profileImage : require('../../assets/img/user.png')} alt="" />
                                                <p>{director.name}</p>
                                            </li>
                                        )) : <li className="cm_empty"><Empty description="No Directors Found" /></li>
                                    }
                                </ul>
                        ) : (
                            <Fragment>
                                <div className="d-flex align-items-center chat_tabs_back" style={{ cursor: 'pointer', padding: '8px 0' }} onClick={handleBackToDirectors}>
                                    <IoChevronBackOutline size={20} />
                                    <span className="ms-2">{selectedDirector.name}</span>
                                </div>
                                {renderConversationList(list, handleDirectorChatClick, loader)}
                            </Fragment>
                        )
                    ) : renderConversationList(list, handleClick, loader)
                }


            </div>
            {!(chatTab === DIRECTORS_TAB && !selectedDirector) &&
                <div className="mt-2">
                    <PaginatedComponent
                        activePage={page}
                        itemsCountPerPage={limit}
                        totalItemsCount={totalUser}
                        pageRangeDisplayed={2}
                        onPageChange={handlePageNoChange}
                        isSearch={false}
                    />
                </div>
            }
        </div>

    )
}



const mapStateToProps = state => {
    let { userProfile } = state.user;
    let { getChatUserListCalback, activeUserChatWindow } = state.inbox;
    return {
        userProfile,
        getChatUserListCalback,
        activeUserChatWindow
    };
}

const mapDispatchToProps = dispatch => ({
    getChatUserListCalbackAction: params => dispatch(getChatUserListCalbackAction(params)),
    activeUserChatWindowAction: params => dispatch(activeUserChatWindowAction(params)),
    unreadCountAction: () => dispatch(unreadCountAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatUserList);
